// Maps error-boundary attribution to bounded responder values for experience-alert routing.
// Add entries only when a distinct responder needs routing; every new value increases SignalFX tag cardinality.
const responderByErrorAttribution: Readonly<Record<string, string>> = {
	ccgraphql: 'backend',
};

const mappedResponders = new Set(Object.values(responderByErrorAttribution));

export function getResponderForErrorAttribution(errorAttribution: unknown): string | undefined {
	return typeof errorAttribution === 'string'
		? responderByErrorAttribution[errorAttribution]
		: undefined;
}

export function isMappedResponder(value: unknown): value is string {
	return typeof value === 'string' && mappedResponders.has(value);
}
